import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#6E6E7D",
      "stroke-width": ".875",
      d: "m7.563 13.688.437.437.219-.219.219-.219v-3.5h-.876z",
      style: {"stroke":"color(display-p3 .4296 .4296 .4915)","stroke-opacity":"1"}
    }, null, -1),
    _createElementVNode("path", {
      fill: "#A7A7B1",
      d: "M3.625 9.751h-.547c0 .302.245.547.547.547zm2.082-3.727.287.466.222-.137.034-.258zm4.586 0-.543.071.034.258.222.137zm2.082 3.727v.547a.547.547 0 0 0 .547-.547zM4.938 1.328a.547.547 0 0 0 0 1.094zm6.125 1.094a.547.547 0 0 0 0-1.094zm-7.438 7.33h.547c0-1.379.728-2.587 1.822-3.262l-.287-.466-.287-.465A4.92 4.92 0 0 0 3.078 9.75zm6.668-3.728-.287.466a3.83 3.83 0 0 1 1.822 3.261h1.094A4.92 4.92 0 0 0 10.58 5.56zm2.082 3.727v-.547H8v1.094h4.375zm-2.082-3.727.542-.07-.543-4.15-.542.071-.542.07.542 4.15zM9.75 1.875v-.547h-3.5v1.094h3.5zm-3.5 0-.542-.07-.543 4.149.542.07.543.071.542-4.15zm0 0v-.547H4.938v1.094H6.25zm3.5 0v.547h1.313V1.328H9.75zM3.625 9.751v.547H8V9.204H3.625z",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }